import React, {memo, useContext, useLayoutEffect, useRef, useEffect, } from "react";
//import ReactDOM from 'react-dom';
import { useNavigate, useLocation } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faHome } from '@fortawesome/free-solid-svg-icons';

import { BreadCrumbType } from '../../datatypes/datatypes';

import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';

import AppContext from '../../context/AppContext'
import { DataTableContext } from "./DataTable/DataTableState";
import { DataTableChildContext } from "./DataTable/DataTableChildState";

import { BulkActionType } from "./DataTable/DataTypes";
import { strings } from "../../services/Localization";
import { useDataTableContext } from "./DataTableEngine/shared/Context";
import { AdaptiveThrottler, fetchPageRows, fetchPageState, filterSelectedRowData } from "./DataTableEngine/shared/shared";
import { dialog } from "./ConfirmDialog";
import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { toast } from "react-toastify";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";

interface BreadcrumbComponentProps {
    breadCrumbArr?: BreadCrumbType[];
    showMain?:() =>  void;
    countLabel?: string;
    name?:string;
    isChildTable?: boolean | undefined;
    showBreadcrumb?: boolean;
    SELECTALL_BULKACTION_LIMIT?: number;
}

const BreadcrumbComponent: React.FC<BreadcrumbComponentProps> = ( props ) => {
    const { isChildTable, showBreadcrumb, SELECTALL_BULKACTION_LIMIT } = props;
    const AppContextObj = useContext(AppContext);
    let DataTableContextObj = useContext(DataTableContext);
    const {selectedRowCount, gridApi, setSelectedRowCount, isSelectAllActive, selectedRowData, deSelectedRowData, abortBulkActionRef, isBulkActionRunning, setIsBulkActionRunning, setBulkActionProgress } = useDataTableContext();
    const location = useLocation();

    if(isChildTable) {
        DataTableContextObj = useContext(DataTableChildContext);
    } else {
        DataTableContextObj = useContext(DataTableContext);
    }
    const navigate = useNavigate();
    useLayoutEffect(() => {
        
        AppContextObj.setCountLabel(props.countLabel)

    },[props.countLabel])
    

    useEffect(() => {
    abortBulkActionRef.current = false;

    const handleUnload = () => {
        localStorage.removeItem('isBulkAction');
        setIsBulkActionRunning(false);   // fallback reset
        setBulkActionProgress({ progress: 0, show: false });
    };

    window.addEventListener('beforeunload', handleUnload);

    return () => {
        abortBulkActionRef.current = true;
        localStorage.removeItem('isBulkAction'); // unmount cleanup
        setIsBulkActionRunning(false);   // fallback reset
        window.removeEventListener('beforeunload', handleUnload);
    };
    }, []);

    useEffect(() => {
        // On route change, always cleanup bulk action state
        abortBulkActionRef.current = true;
        localStorage.removeItem('isBulkAction');
        setIsBulkActionRunning(false);
        setBulkActionProgress({ progress: 0, show: false });
    }, [location]);

    let recordCounterId = (props.name) ? props.name : 'data-table';
    const isNst = (String(location.pathname).indexOf('/nst'));
    const redirection = isNst != -1 ? "/nst/network_map" : "/app";
    const selectedRowIds = DataTableContextObj.searchState.selectedRowIds;
       
    const unSelectAll = () => {
        isSelectAllActive.current = false;    
        gridApi?.deselectAll();                                
        selectedRowData.current.clear();    
        deSelectedRowData.current.clear();       
        setSelectedRowCount(0);        
        DataTableContextObj.setSearchState(prev => ({
            ...prev,
            selectedRowIds: [],
            selectedRowData: [],
        }));                    
    };

    const totalRecordsCount = DataTableContextObj.searchState?.totalRecords ?? 0;
    const selectedRowIdsCount = DataTableContextObj.searchState?.selectedRowIds?.length ?? 0;
    const displaySelectedRowCount = isSelectAllActive.current ? selectedRowCount : selectedRowIdsCount;
    /*
    console.log("BreadcrumbComponent render", {
        displaySelectedRowCount,
    });
    console.log(selectedRowData.current.size, deSelectedRowData.current.size, selectedRowIds.length)
    */
    
return (
        <div className="d-flex flex-wrap align-items-center flex-sm-row justify-content-start align-items-start" style={{ paddingTop:'10'}}>
            <div className="breadcrumb"
            style={isBulkActionRunning ? { pointerEvents: 'none', opacity: 0.6 } : {}}
            >
                { props?.breadCrumbArr && props.breadCrumbArr?.length > 0 &&
                <div className="active cursor-pointer" style={{cursor: "pointer"}}>
                    <FontAwesomeIcon icon={faHome} onClick={() => navigate(redirection)}/>
                </div>
                }
                {props?.breadCrumbArr?.map(function(item, index) {
                    if(item?.label){
                        return (<BreadcrumbComponentItem item={item} index={index}  key={index}  selectedRowIds={selectedRowIds} />)
                    }
                    return null;
                })}
            </div>
           
         {/* Abort button after breadcrumb items, only when bulk action is running */}
        {isBulkActionRunning && (
            <OverlayTrigger
                placement="right"
                overlay={
                    <Tooltip id="tooltip-bulk-abort-warning">
                        Interrupting will stop the bulk process and some records might not be processed.
                    </Tooltip>
                }
            >
            <button
                className="abort-btn"
                onClick={() => { abortBulkActionRef.current = true; }}
            >
                    <FontAwesomeIcon icon={faTimes} /> Abort Bulk Action
            </button>
            </OverlayTrigger>
        )}
        {/* Only show the rest if not running a bulk action */}
        {!isBulkActionRunning && (
             <div className="d-flex flex-wrap align-items-center">
                {showBreadcrumb && totalRecordsCount > 0 ?
                <div className="ms-2">
                    <small>
                     <span>{strings.TABLE_COUNT_ALL}</span> 
                        <span>(
                                <span style={{fontWeight: "bold"}}>
                                    {totalRecordsCount}
                                </span>
                            ) 
                        </span>         
                    </small>     
                </div> 

                : 
                <div className="ms-2" id={`${recordCounterId}-record-count`}></div>}
      
                {showBreadcrumb && displaySelectedRowCount > 0 && totalRecordsCount > 0 &&
                <>
                   <div className="ms-2"><small>
                        |&nbsp;
                        <span>{strings.TABLE_COUNT_SELECTED}</span> 
                        <span>(
                                <span style={{fontWeight: "bold"}}>
                                    {displaySelectedRowCount ?? 0}
                                </span>
                            ) 
                        </span>
                        
                        &nbsp;| &nbsp;                 
                        <a style={{cursor : "pointer",    
                        }}
                        className="text-info" 
                         onClick={unSelectAll}
                        onMouseEnter={(e) => {
                            const el = e.target as HTMLAnchorElement;
                            el.style.color = '#0A58CA';
                            el.className="";
                        }}
                        onMouseLeave={(e) => {
                            const el = e.target as HTMLAnchorElement;
                            el.className="text-info";
                        }}
                         >{strings.TABLE_BUTTON_CLEAR_SELECTED}</a>
                    </small>
                    </div>
                    {DataTableContextObj.searchState?.dataTableOption?.bulkActions && DataTableContextObj.searchState?.dataTableOption?.bulkActions.length > 0 &&
                   (<> 
                    &nbsp;| 
                    <div className="ms-2 custom-dropdown d-flex">
                        <RenderBulkActionDropDown 
                            bulkActions={DataTableContextObj.searchState.dataTableOption.bulkActions} 
                            DataTableContextObj={DataTableContextObj}
                            selectedRowsData={selectedRowData.current ? Array.from(selectedRowData.current?.values()) : []}
                            SELECTALL_BULKACTION_LIMIT={SELECTALL_BULKACTION_LIMIT}
                            unSelectAll={unSelectAll}
                            displaySelectedRowCount={displaySelectedRowCount}
                            abortBulkActionRef={abortBulkActionRef}
                            setIsBulkActionRunning={setIsBulkActionRunning}
                        />
                    </div>
                    </>
                    )}
                   
                </>
            } 
            <div style={{marginLeft:'5px', marginTop: '8px'}}>
                <div className="react-spinner"></div>
            </div>
            </div> 
        )}
        </div>
    )
}

    interface RenderFontAwesomeIconProps {
        icon: any;
        size?: any;
        color?: any;
    }

    const RenderFontAwesomeIcon: React.FC<RenderFontAwesomeIconProps> = ( props ) => {
        try {
            let size = (props.size) ? props.size : 'sm';
            if(props.icon.prefix != null) {
                return (<FontAwesomeIcon icon={props.icon} size={size} />)
            }else {
                return null;
            }
            
        }catch (e) {
            return null;
        }
    }


    interface RenderBulkActionDropDownProps {
        bulkActions?: BulkActionType[];
        DataTableContextObj: any;
        selectedRowsData?: any[];
        SELECTALL_BULKACTION_LIMIT? : number;
        unSelectAll: () => void;
        displaySelectedRowCount?: number;
        abortBulkActionRef: React.MutableRefObject<boolean>;
        setIsBulkActionRunning?: (running: boolean) => void;
    }

    const RenderBulkActionDropDown: React.FC<RenderBulkActionDropDownProps> = memo(({ bulkActions, DataTableContextObj, selectedRowsData, SELECTALL_BULKACTION_LIMIT, unSelectAll, displaySelectedRowCount, abortBulkActionRef, setIsBulkActionRunning }) => {    
        const {  isSelectAllActive, fetchUrlRef, queryParamsStringRef, fetchUrlParamsRef,primaryKeyRef, selectedRowData, deSelectedRowData, setBulkActionProgress, bulkActionProgress } = useDataTableContext();
        const selectedRowCount = selectedRowData.current?.size;
        const progressRef = useRef(0);
        const showProgressRef = useRef(false);
        const throttler = new AdaptiveThrottler();

        const DISABLE_SELECT_ALL_MSG = (actionName) => `For ${actionName ?? 'this bulkAction'}, items must be selected page-wise. Select All cannot be used here.`;

        // Function to update progress and notify via context
        const updateProgressAndNotify = React.useCallback((newProgress: number, show: boolean) => {
            progressRef.current = newProgress;
            showProgressRef.current = show;
            if (setBulkActionProgress) {
                setBulkActionProgress({ progress: newProgress, show });
            }
        }, [setBulkActionProgress]);

        const processSelectAllBulkAction = async ( actionFn: (rows: any[], serviceIndex: number) => void | Promise<void>, serviceIndex: number, SELECTALL_BULKACTION_LIMIT? : number, selectAllBulkActionWarningMessage?: string) => {
            // Always reset abort ref before starting a new bulk action so won't carry over from previous state
            abortBulkActionRef.current = false;
            const SELECT_ALL_BULKACTION_INTERRUPT_MSG = "Bulk action interrupted. Some items may not have been processed.";
            const DELAY_THROTTLE_TIME_MS = 2000;  // time to pause when throttler indicates
            const DELAY_BATCH_MS = 300;  // time to wait between progress updates to allow UI to breathe & Avoid API hammering
            const DELAY_UI_UPDATE_MS = 10;  // time to wait between progress updates to allow UI to breathe
            // Helper function to update progress with immediate notification
            const updateProgress = async (processedItems: number, totalItems: number) => {
                try {
                    const progress = ((processedItems / totalItems) * 100);
                    updateProgressAndNotify(Math.min(Number(progress.toFixed(2)), 100), true);
                    await new Promise(resolve => setTimeout(resolve, DELAY_UI_UPDATE_MS));
                } catch (error) {
                    console.error("Error updating progress:", error);
                    updateProgressAndNotify(0, false);
                }
            };

        try {
            localStorage.removeItem('isBulkAction');
            updateProgressAndNotify(0, false);
            const confirmed = await dialog({
                title: "Confirm Bulk Action",
                description: selectAllBulkActionWarningMessage ?? strings.DEFAULT_SELECTALL_BULKACTION_CONFIRM_MESSAGE,
                actionLabel: "Confirm",
                cancelLabel: "Cancel",
                faIcon: faTriangleExclamation
            });
            if (!confirmed) {
                if (setIsBulkActionRunning) setIsBulkActionRunning(false);
                return; 
            }
            if (setIsBulkActionRunning) setIsBulkActionRunning(true);

            // Initialize progress
            showProgressRef.current = true;
            await updateProgress(0, 100); // Start at 0%
            
            if(displaySelectedRowCount > SELECTALL_BULKACTION_LIMIT) {
                toast.info(
                    `Bulk operation started. Updates will appear after every ${SELECTALL_BULKACTION_LIMIT} items processed.`
                );
            }

            // Mark bulk action started in localStorage so your dialog logic can auto-confirm next popups if any
            localStorage.setItem('isBulkAction', 'true');
            const limit = SELECTALL_BULKACTION_LIMIT ?? 100;
            let oldPageStates = await fetchPageState(fetchUrlRef.current,fetchUrlParamsRef.current, queryParamsStringRef.current, limit);
            const primaryKey = primaryKeyRef.current;

            // Calculate total items to process
            const totalItemsToProcess = oldPageStates.total - deSelectedRowData.current.size;
            let totalProcessedItems = 0;

            // Process the first pageState immediately
            if (oldPageStates.pageStates.length > 0) {
                if (abortBulkActionRef.current){
                    if (setIsBulkActionRunning) setIsBulkActionRunning(false);
                    toast.info(SELECT_ALL_BULKACTION_INTERRUPT_MSG);
                    return;
                }
                const firstPageState = oldPageStates.pageStates[0];
                const rows = await fetchPageRows(fetchUrlRef.current, fetchUrlParamsRef.current, queryParamsStringRef.current, firstPageState, limit);
                const filteredRows = filterSelectedRowData(rows, deSelectedRowData.current, primaryKey);

                if (filteredRows.length > 0) {
                    if (abortBulkActionRef.current){
                        if (setIsBulkActionRunning) setIsBulkActionRunning(false);
                        toast.info(SELECT_ALL_BULKACTION_INTERRUPT_MSG);
                        return;
                    }
                    const batchStart =  performance.now();
                    await actionFn(filteredRows, serviceIndex);
                    const batchEnd =  performance.now();
                    const batchDuration = batchEnd - batchStart;
                    
                    throttler.recordBatchTime(batchDuration);
                    
                    if (throttler.shouldPause()) {
                        await new Promise(res => setTimeout(res, DELAY_THROTTLE_TIME_MS));
                    }
                    totalProcessedItems += filteredRows.length;
                    await updateProgress(totalProcessedItems, totalItemsToProcess);
                }
            }
            // Now fetch pageStates again to compare totals
            const newPageStates = await fetchPageState(fetchUrlRef.current, fetchUrlParamsRef.current, queryParamsStringRef.current, limit);
            const oldTotal = oldPageStates.total;
            const newTotal = newPageStates.total; 
            if (newTotal !== oldTotal) {
                let keepGoing = true;
                while (keepGoing) {
                    if (abortBulkActionRef.current) {
                        if (setIsBulkActionRunning) setIsBulkActionRunning(false);
                        toast.info(SELECT_ALL_BULKACTION_INTERRUPT_MSG);
                        return;
                    }
                    // Stop if we've processed the intended number of items
                    if (totalProcessedItems >= totalItemsToProcess) {
                        keepGoing = false;
                        break;
                    }
                    const latestPageStateResult = await fetchPageState(fetchUrlRef.current, fetchUrlParamsRef.current, queryParamsStringRef.current, limit);
                    const latestTotal = latestPageStateResult.total;
                    
                    if(latestPageStateResult.pageStates?.length == 0 || latestTotal <= 0) {
                        keepGoing = false;
                        break;
                    }

                    if (latestPageStateResult.pageStates.length > 0) {
                        if (abortBulkActionRef.current){
                            if (setIsBulkActionRunning) setIsBulkActionRunning(false);
                            toast.info(SELECT_ALL_BULKACTION_INTERRUPT_MSG);
                            return;
                        }
                        const firstPageState = latestPageStateResult.pageStates[0];
                        const rows = await fetchPageRows(fetchUrlRef.current, fetchUrlParamsRef.current, queryParamsStringRef.current, firstPageState, limit);
                        const filteredRows = filterSelectedRowData(rows, deSelectedRowData.current, primaryKey);
                        if (filteredRows.length > 0) {
                            if (abortBulkActionRef.current){
                                if (setIsBulkActionRunning) setIsBulkActionRunning(false);
                                toast.info(SELECT_ALL_BULKACTION_INTERRUPT_MSG);
                                return;
                            }
                            const batchStart =  performance.now();
                            await actionFn(filteredRows, serviceIndex);
                            const batchEnd =  performance.now();
                            const batchDuration = batchEnd - batchStart;
                            throttler.recordBatchTime(batchDuration);
                            if (throttler.shouldPause()) {
                                await new Promise(res => setTimeout(res, DELAY_THROTTLE_TIME_MS));
                            }
                            totalProcessedItems += filteredRows.length;
                            // Clamp processed items to intended total
                            if (totalProcessedItems >= totalItemsToProcess) {
                                keepGoing = false;
                                break;
                            }
                            const currentProgress = ((totalProcessedItems / totalItemsToProcess) * 100);
                            updateProgressAndNotify(Math.min(Number(currentProgress.toFixed(2)), 100), true);
                    }
                    // Avoid hammering the API
                    await new Promise(res => setTimeout(res, DELAY_BATCH_MS));
                    } else {
                        keepGoing = false;
                        break;
                    }
                }
            } else {
                // when total didn't change for 0th pageState[], process remaining pageStates (except the first one already done)
                for (let i = 1; i < oldPageStates.pageStates.length; i++) {
                    if (abortBulkActionRef.current){
                        if (setIsBulkActionRunning) setIsBulkActionRunning(false);
                        toast.info(SELECT_ALL_BULKACTION_INTERRUPT_MSG);
                        return;
                    }
                    const pageState = oldPageStates.pageStates[i];
                   
                    const rows = await fetchPageRows(fetchUrlRef.current, fetchUrlParamsRef.current, queryParamsStringRef.current, pageState, limit);
                    const filteredRows = filterSelectedRowData(rows, deSelectedRowData.current, primaryKey);
                    if (filteredRows.length > 0) {
                        if (abortBulkActionRef.current) {
                            if (setIsBulkActionRunning) setIsBulkActionRunning(false);
                            toast.info(SELECT_ALL_BULKACTION_INTERRUPT_MSG);
                            return;
                        }
                        const batchStart =  performance.now();
                        await actionFn(filteredRows, serviceIndex);
                        const batchEnd =  performance.now();
                        const batchDuration = batchEnd - batchStart;
                        throttler.recordBatchTime(batchDuration);
                        if (throttler.shouldPause()) {
                            await new Promise(res => setTimeout(res, DELAY_THROTTLE_TIME_MS));
                        }
                        totalProcessedItems += filteredRows.length;
                        const currentProgress = ((totalProcessedItems / totalItemsToProcess) * 100);
                        updateProgressAndNotify(Math.min(Number(currentProgress.toFixed(2)), 100), true);
                        // Small delay to ensure UI updates
                        await new Promise(resolve => setTimeout(resolve, DELAY_UI_UPDATE_MS));
                    }
                }
            }
            await unSelectAll();
            await updateProgress(100, 100);
        } catch (error) {
            if (abortBulkActionRef.current) {
                // Optionally show a toast or log cancellation

                if (setIsBulkActionRunning) setIsBulkActionRunning(false);
                toast.info(SELECT_ALL_BULKACTION_INTERRUPT_MSG);
            } else {
                if (setIsBulkActionRunning) setIsBulkActionRunning(false);
                console.error("Error processing all page states:", error);
                toast.error("An error occurred during bulk operation. Some items may not have been processed.");
            }
            await unSelectAll();
            throw error; 
        } finally {
            try {
                // If aborted, hide the progress bar immediately and do not set to 100%
                if (abortBulkActionRef.current) {
                    updateProgressAndNotify(0, false);
                } else if (bulkActionProgress && bulkActionProgress?.show) {
                    await updateProgress(100, 100);
                    await new Promise(resolve => setTimeout(resolve, DELAY_BATCH_MS));
                    updateProgressAndNotify(100, false);
                }
            } catch (error) {
                console.error("Error in cleanup:", error);
            } finally {
                localStorage.removeItem('isBulkAction');
                if (setIsBulkActionRunning) setIsBulkActionRunning(false);
            }
        }
        };


        if (bulkActions && bulkActions.length > 0) {
            let addServiceHeader : "yes" | "no" | "added" = "no";
            const list = bulkActions.map(function (action: BulkActionType, index: number) {
                let row = null;
                let serviceIndex = -1;
                if (addServiceHeader === "yes") {
                    addServiceHeader = "added";
                }
                let serviceName = ""
                if(action.render && action.text &&  selectedRowCount > 0) {
    
                    let outFromLoop = false;
                    for(let i=0;i< selectedRowCount ;i++) {
                        if(!selectedRowsData[i].suspended) {
                            const services = selectedRowsData[i].services
                            if(services) {
                                for(let j = 0; j < services.length; j++) {
                                    if(services[j].name == action.text) {
                                        if (addServiceHeader === "no") {
                                            addServiceHeader = "yes";
                                        } 
                                        serviceName = services[j].name
                                        row = selectedRowsData[i];
                                        serviceIndex = j;
                                        outFromLoop = true
                                        break;             
                                    }
                                }
                            }
                            if(outFromLoop) break;
                        }
                    }
                }
                if (action.type === 'action' && (((action.hasOwnProperty('visible') && action.visible(row, serviceIndex, serviceName) === true) || action.hasOwnProperty('visible') === false))) {
                    if(action.hasOwnProperty('visible') === false && action.hasOwnProperty('bulkActionVisible')) {
                        if(!action.bulkActionVisible(selectedRowsData)) return null;
                    }
                    // Allow actions to explicitly disable Select All bulk processing across pages
                    const disableSelectAll = action?.disableSelectAllPageBulkAction === true;
                    return (<React.Fragment key={`action-${index}`}>
                        { addServiceHeader == "yes" &&
                        <Dropdown.Header key={`header-${index}`}>{ strings.TABLE_BUTTON_BULK_SERVICE_ACTIONS }</Dropdown.Header>
                        }
                        {<Dropdown.Item
                            disabled={isSelectAllActive.current? false : (selectedRowsData && selectedRowsData.length > 0 ? false : true)}
                            key={index}
                            eventKey={index}
                            onClick={async () => {
                                try {
                                    if (disableSelectAll && isSelectAllActive.current) {
                                        toast.info(DISABLE_SELECT_ALL_MSG(action?.text));
                                        return;
                                    }
                                    if (isSelectAllActive.current && !action?.handleSelectAllInternally) {
                                        await processSelectAllBulkAction(async (rows, index) => { action?.action(rows, index);}, serviceIndex, SELECTALL_BULKACTION_LIMIT, action?.selectAllBulkActionWarningMessage);
                                    } else {
                                        await action.action(selectedRowsData, serviceIndex);
                                        await unSelectAll();
                                    }
                                } catch (error) {
                                    console.error("Error in bulk action:", error);
                                }
                            }}>
                            {(action.render && row) ? (
                                <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5, marginBottom: 5 }}>
                                    {<div style={{ marginRight: 5, marginLeft: 5 }}>{action.render(row, action.text, serviceIndex, serviceName)}</div>}
                                </div>
                            ) : (
                                <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5, marginBottom: 5 }}>
                                    {action.icon && <div style={{ marginRight: 5, marginLeft: 5 }}><RenderFontAwesomeIcon icon={action.icon} /></div>}
                                    {action.text}
                                </div>
                            )}
                        </Dropdown.Item>}</React.Fragment>)
                } else if (action.type === 'separator') {
                    return (<Dropdown.Divider key={index} />)
                } else if (action.type === "header") {
                    return (
                    <Dropdown.Header key={index}>{action.text}</Dropdown.Header>)
                } else {
                    return null;
                } 
            })   

            return (
                <>
                <Dropdown   autoClose="outside">
                    <Dropdown.Toggle variant="dark" size="sm" id="bulk-action-dropdown-components">
                       &nbsp; {strings.TABLE_BUTTON_BULK_ACTIONS}&nbsp; 
                    </Dropdown.Toggle>
                    <Dropdown.Menu  align="end" title="Dropdown end" id="dropdown-menu-align-end" className="breadcrumb-dropdown-menu">
                        {list}
                    </Dropdown.Menu>
                </Dropdown>
                </>
            )

        }
        else {
            return (<></>);
        }
    
    })

interface BreadcrumbComponentItemProps {
    item:any;
    index:number;
    child?:JSX.Element;
    selectedRowIds?: any;
}

const BreadcrumbComponentItem: React.FC<BreadcrumbComponentItemProps> = ( props ) => {
    let { item , index, selectedRowIds } = props;
    if (!selectedRowIds) selectedRowIds = [];

    const navigate = useNavigate();
    
    let nav =  (item.url) ? (item.url === '-1') ? () => { navigate(-1) } : () => { navigate(item.url,{replace: false}) } : () => {};
    

    return (
        <div onClick={  nav  } style={{cursor: 'pointer'}} className="active cursor-pointer" key={index}>
            {item.label} 
            {props.child}
            {(item.comment && selectedRowIds.length == 0) && 
            <small className="breadcrumb-comment" title={item.comment}>
            {item.comment}
            </small>
            } 
        </div>
    )
}

export { BreadcrumbComponent };


